import { createSignal } from '@rwwa/rwwa-rx-state-machine'

export const Initialise = createSignal<{ raceKey: string; testing?: boolean }>('Initialise')
export const Teardown = createSignal('Teardown')

export const ShowTopRating = createSignal('ShowTopRating')
export const ShowAllRating = createSignal('ShowAllRating')
export const ShowSpeedMap = createSignal('ShowSpeedMap')
export const ShowQuaddieTips = createSignal('ShowQuaddieTips')
export const ChangeQuaddieValue = createSignal('ChangeQuaddieValue')

export const SelectAcceptor = createSignal<{ acceptorNumber: number; isFixed: boolean }>(
  'SelectAcceptor'
)
export const SelectQuaddie = createSignal<{ raceNumbers: number[]; acceptorNumbers: number[][] }>(
  'SelectQuaddie'
)
